import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AudiogramClip} from 'storyboard-renderer';

@Component({
  selector: 'app-audiogram-editor',
  templateUrl: './audiogram-editor.component.html',
  styleUrls: ['./audiogram-editor.component.scss']
})
export class AudiogramEditorComponent implements OnInit {

  @Input() clip;

  colorToggle = false;
  colorMiddleToggle = false;
  colorEndToggle = false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public getWaveTypes(){
    return AudiogramClip['wavePatterns'];
  }

  cpToggleChange(open: boolean) {
    this.colorToggle = open;
  }

  finishTextEditing() {
    this.activeModal.close(this.clip);
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/audiogram-editor/audiogram-editor.component.ts